export default {
  "$vuetify": {
    "dataTable": {
      "itemsPerPageText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elementos por página:"])},
      "pageText": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), "-", _interpolate(_list(1)), " de ", _interpolate(_list(2))])},
      "noDataText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No hay datos disponibles"])}
    },
    "snackbar": {
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Este es un mensaje personalizado"])}
    }
  }
}